<section class="modal-content modal-content-right">
  <button type="button" class="close" (click)="close()" aria-label="Close">
    <span aria-hidden="true">&times;</span>
  </button>

  <section class="flex flex-column">
    <div class="header-content mx-6 pt-6">    
      <h5>{{ !editMode ? 'Add Customer Address' : 'Edit Customer Address' }}</h5>
    </div>

    <div class="body-content py-8 px-6">
      <form novalidate id="addressForm" #addressForm="ngForm" (ngSubmit)="onSave(addressForm.valid)">
        <div class="flex flex-col gap-5">
          <cj-form-field class="flex-grow-1">
            <cj-form-label>Street address</cj-form-label>
            <input
              cjInput
              fullWidth
              required
              type="text"
              name="address1"
              placeholder="House number, street name, building name or village name"
              [disabled]="isLoading"
              [status]="address1.invalid && isSubmitted ? 'danger' : ''"
              [(ngModel)]="customerAddress.StreetAddress"
              #address1="ngModel"
            />
          </cj-form-field>

          <cj-form-field class="flex-grow-1">
            <cj-form-label>Address 2</cj-form-label>
            <input
              cjInput
              fullWidth
              type="text"
              name="address2"
              [disabled]="isLoading"
              [status]="address2.invalid && isSubmitted ? 'danger' : ''"
              [(ngModel)]="customerAddress.Address2"
              #address2="ngModel"
            />
          </cj-form-field>

          <div class="flex items-center gap-3">
            <cj-form-field class="flex-grow-1 w-full">
              <cj-form-label>City</cj-form-label>
              <input
                cjInput
                fullWidth
                required
                type="text"
                name="city"
                [disabled]="isLoading"
                [status]="city.invalid && isSubmitted ? 'danger' : ''"
                [(ngModel)]="customerAddress.City"
                #city="ngModel"
              />
            </cj-form-field>
            <div class="flex-grow-1 select-field  w-full">
              <label class="required" [class.text-hint]="customerAddress.CountryId !== 230">State</label>
              <select
                required
                name="usStates"
                [class.invalid]="usStates.invalid && isSubmitted && !customerAddress.State"
                [disabled]="isLoading || customerAddress.CountryId !== 230"
                [(ngModel)]="customerAddress.State"
                #usStates="ngModel"
              >
                <ng-container *ngFor="let state of states">
                  <option [value]="state.abbreviation">
                    {{ state.name }}
                  </option>
                </ng-container>
              </select>
            </div>
          </div>

          <div class="flex items-center gap-3">
            <div class="flex-grow-1 select-field w-full">
              <label>Country</label>
              <select
                name="country"
                [disabled]="isLoading"
                [ngModel]="customerAddress.CountryId"
                (ngModelChange)="onCountryChanged($event)"
              >
                <ng-container *ngFor="let country of countries">
                  <option [ngValue]="country.Id">
                    {{ country.CountryName }}
                  </option>
                </ng-container>
              </select>
            </div>
            <cj-form-field class="flex-grow-1 w-full">
              <cj-form-label>Zip Code</cj-form-label>
              <input
                cjInput
                fullWidth
                required
                type="text"
                name="zip"
                placeholder="Customer Zip Code"
                [disabled]="isLoading"
                [status]="zip.invalid && isSubmitted ? 'danger' : ''"
                [(ngModel)]="customerAddress.ZipCode"
                #zip="ngModel"
              />
            </cj-form-field>
          </div>

          <div class="flex items-center gap-3">
            <div class="select-field w-6/12">
              <label>Address Type</label>
              <select
                name="addressType"
                [disabled]="isLoading"
                [ngModel]="selectedAddressType"
                (ngModelChange)="onAddressTypeSelected($event)"
              >
                <ng-container *ngFor="let type of addressTypes">
                  <option [value]="type.value">
                    {{ type.name }}
                  </option>
                </ng-container>
              </select>
            </div>
            <div class="mt-4">
              <cj-checkbox
                [disabled]="isLoading"
                [(ngModel)]="customerAddress.IsDefault" 
                [ngModelOptions]="{ standalone: true }"
              >
                <span class="font-medium">Set as Default</span>
              </cj-checkbox>
            </div>
          </div>
        </div>
      </form>
    </div>

    <div class="footer-content flex justify-end gap-2.5 mx-6 pb-6">
      <button
        cjButton
        outline
        size="large"
        [disabled]="isLoading"
        (click)="close()"
      >Cancel</button>
      <button
        cjButton
        type="submit"
        form="addressForm"
        size="large"
        [disabled]="isLoading"
      >
        <span *ngIf="isLoading" class="mr-2">
          <cj-icon class="fa-spin" icon="spinner" pack="font-awesome-solid"></cj-icon>
        </span>
        {{ !isLoading ? 'Save' : 'Saving...' }}
      </button>
    </div>
  </section>
</section>
